import React from 'react';
import { useLocationContext } from '../../context/LocationContext';

export default function Location(): React.JSX.Element {
  const { city, state } = useLocationContext();

  return (
    <p
      data-qa="location"
      data-testid="location"
      className="m-0 mt-[6px] flex justify-center text-center align-middle text-blue-6 tl-header-s"
    >
      <svg
        className="mr-8"
        width="14"
        height="19"
        viewBox="0 0 14 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99943 0.946777C10.5081 0.946777 13.3524 3.79109 13.3524 7.29972C13.3524 12 7.7406 18.5127 7.7406 18.5127C7.57191 18.762 7.29943 18.9216 6.99943 18.9468C6.70731 18.9211 6.43893 18.7754 6.25825 18.5444C6.25825 18.5444 0.646484 12 0.646484 7.29972C0.686527 3.80781 3.50751 0.98682 6.99943 0.946777ZM9.37115 7.16188C9.38277 5.83866 8.32263 4.75494 6.99947 4.73745C5.66445 4.73157 4.57583 5.80599 4.56418 7.14098C4.5643 8.46425 5.634 9.53852 6.95726 9.54428C8.28052 9.55003 9.35953 8.4851 9.37115 7.16188Z"
          fill="#122946"
        />
      </svg>
      <span>
        {city}, {state}
      </span>
    </p>
  );
}
